import { render } from "./BgVisuals.vue?vue&type=template&id=1fea70fa"
import script from "./BgVisuals.vue?vue&type=script&lang=js"
export * from "./BgVisuals.vue?vue&type=script&lang=js"

import "./BgVisuals.vue?vue&type=style&index=0&id=1fea70fa&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__